import { jsx as _jsx } from "react/jsx-runtime";
import ContentLoader from 'react-content-loader';
export const SkeletonInfo = ({ widthFull = false, widthHalf = false, backgroundColor, foregroundColor, height, ...rest }) => {
    // const widthValue = widthFull ? 100 : widthHalf ? 85 : 40;
    return (_jsx(ContentLoader, { speed: 2, width: '100%', height: height ?? '18', viewBox: `0 0 400 ${height ?? '18'}`, backgroundColor: `var(--tg-theme-secondary-bg-color)`, foregroundColor: 'var(--tg-theme-bg-color)', ...rest, children: _jsx("rect", { x: "0", y: "0", rx: "10", ry: "10", width: "100%", height: height ?? '18' }) }));
};
